import Radio from "./Radio";

const RadioNameonly = (props) => <Radio {...props} nameOnly />;

export default RadioNameonly;
